import type { CSSProperties, ReactNode } from "react";

import { styled } from "simplydo/react/styled";

const Media = styled.div<{ $image?: string; $height: number }>`
  width: 100%;
  height: ${({ $height }) => $height}px;
  border-radius: 16px;
  background-size: cover;
  background-position: center center;
  background-color: #e8ebef;
  background-image: ${({ $image }) => ($image ? `url(${$image})` : "none")};
  flex: none;
`;

type EntityBannerMediaProps = {
  image?: string | null;
  height?: number;
  mobileHeight?: number;
  style?: CSSProperties;
  className?: string;
  children?: ReactNode;
};

const EntityBannerMedia = ({
  image,
  height = 200,
  style,
  className,
  children,
}: EntityBannerMediaProps) => {
  if (!image && !children) return null;

  return (
    <Media
      $image={image ?? undefined}
      $height={height}
      style={style}
      className={className}
    >
      {children}
    </Media>
  );
};

export default EntityBannerMedia;
